var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4 overflow-hidden card-container d-flex flex-column justify-space-between",attrs:{"min-height":"176","outlined":""}},[_c('v-skeleton-loader',{attrs:{"type":"text","width":"120"}}),_c('v-skeleton-loader',{attrs:{"type":"paragraph","width":"160"}}),_c('v-skeleton-loader',{attrs:{"type":"text","width":"60"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }